import { Cell, CellContainer, Container } from './styles';

const TasksPopper = ({ isOpen, onClose, currentTasks = [] }) => {
  return (
    <Container open={isOpen}>
      <CellContainer>
        {currentTasks.length > 1
          ? currentTasks.map((item, index) => (
              <Cell key={index}>
                <span>{item.label}</span>
              </Cell>
            ))
          : null}
      </CellContainer>
    </Container>
  );
};

export default TasksPopper;
